var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.392c3.542 0 6.475-2.94 6.475-6.475 0-3.542-2.94-6.475-6.481-6.475C3.458.442.525 3.375.525 6.917c0 3.536 2.94 6.475 6.475 6.475ZM4.867 9.583a.52.52 0 0 1-.52-.527c0-.14.05-.273.152-.368l1.758-1.765L4.5 5.165a.508.508 0 0 1-.152-.368.51.51 0 0 1 .52-.52c.146 0 .26.05.362.145L7 6.187l1.784-1.771a.48.48 0 0 1 .362-.152.52.52 0 0 1 .526.52.49.49 0 0 1-.158.375L7.749 6.923l1.758 1.759a.485.485 0 0 1 .159.374.527.527 0 0 1-.533.527.502.502 0 0 1-.375-.152L7 7.666 5.248 9.431a.527.527 0 0 1-.38.152Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.4c6f15b217cc335f10c8030773818eac.svg";
export { ForwardRef as ReactComponent };